import React from 'react';
import { bool, elementType, node, oneOfType, string } from 'prop-types';
import { Text, Stack } from '@chaser/components';

const LabeledBlock = ({
  label,
  required,
  color = 'Mid Neutral 1',
  fontSize,
  as: Comp = 'label',
  children,
  className = undefined,
}) => {
  return (
    <Stack gap="xsmall" as={Comp} className={className}>
      <Text color={color} fontSize={fontSize}>
        {label}
        {required && <Text color="Red">*</Text>}
      </Text>
      {children}
    </Stack>
  );
};

LabeledBlock.propTypes = {
  color: string,
  fontSize: string,
  required: bool,
  children: node.isRequired,
  label: oneOfType([string, node]),
  as: elementType,
  className: string,
};

export default LabeledBlock;
